import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { BodyText, Title, View } from 'modules/styled';

const TextTooltipComponent = ({ text, title }) => (
  <View sx={{ maxWidth: 32 * 8, flex: 1, flexDirection: 'column' }}>
    {title ? <Title sx={{ color: 'white', mb: 1 }}>{title}</Title> : null}
    {text ? <BodyText sx={{ color: 'white' }}>{text}</BodyText> : null}
  </View>
);

TextTooltipComponent.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
};

const TOOLTIPS = {
  POST: {},
  TEXT: TextTooltipComponent,
};

export const TextTooltip = ({ id, type, ...rest }) => {
  return (
    <ReactTooltip
      className="reactTooltip"
      id={id}
      effect="solid"
      type={type || 'light'}
      getContent={(dataTip) => {
        const data = JSON.parse(dataTip);
        if (!data) return null;

        const { type, props } = data; // eslint-disable-line
        if (!TOOLTIPS[type]) return null;

        const TT = TOOLTIPS[type];
        return <TT {...props} />;
      }}
      {...rest}
    />
  );
};

TextTooltip.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
};
